import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="h-screen flex items-center justify-center bg-[#F4F4F5] px-6">
      <div className="bg-white border border-border rounded-sm p-10 max-w-md w-full text-center flex flex-col items-center gap-4" data-testid="payment-cancel">
        <XCircle className="w-12 h-12 text-neutral-400" />
        <h1 className="font-display text-2xl tracking-tight font-semibold">Pago cancelado</h1>
        <p className="text-neutral-500 text-sm">No se ha realizado ningún cargo.</p>
        <Button onClick={() => navigate("/credits")} className="rounded-sm bg-[#002FA7] hover:bg-[#00248a] mt-2">
          Volver a créditos
        </Button>
      </div>
    </div>
  );
}
